{
	"domain-model": {
		"activeFollowUpPlan": {
			"list": {
				"emptyData": {
					"title": "Absence de plans de suivi actifs",
					"message": "Aucun plan de suivi actif n’existe actuellement."
				}
			}
		},
		"assessment": {
			"list": {
				"emptyData": {
					"title": "Aucune echelles",
					"message": "Il n'y a pas encore d'échelles."
				}
			},
			"property": {
				"plannedDate": {
					"label": "Date planifiée",
					"placeholder": "Sélectionnez une date"
				},
				"purpose": {
					"label": "Objectif"
				}
			}
		},
		"careFacility": {
			"list": {
				"emptyData": {
					"title": "Aucun établissement de soins trouvé",
					"message": "Il n'y a pas encore d'établissements de soins créés."
				}
			}
		},
		"closedFollowUpPlan": {
			"list": {
				"emptyData": {
					"title": "Absence de plans de suivi finalisés",
					"message": "Aucun plan de suivi finalisé n’existe actuellement."
				}
			}
		},
		"communication": {
			"list": {
				"emptyData": {
					"title": "Aucun message trouvé",
					"message": "Il n'y a pas de messages à afficher."
				},
				"search": {
					"placeholder": "Rechercher des messages..."
				}
			},
			"property": {
				"attachments": {
					"label": "Pièce(s) jointe(s)"
				},
				"from": {
					"label": "De"
				},
				"message": {
					"label": "Message"
				},
				"recipients": {
					"label": "Destinataires"
				},
				"sender": {
					"label": "Expéditeur"
				},
				"sentOn": {
					"label": "Date"
				},
				"subject": {
					"label": "Sujet",
					"placeholder": "Ajoutez le sujet"
				},
				"to": {
					"label": "À",
					"placeholder": "Trouver groupe(s) de communication"
				}
			}
		},
		"communicationGroup": {
			"list": {
				"emptySearch": {
					"title": "Aucun groupe de communication trouvé",
					"message": "Aucun groupe de communication ne correspond à votre recherche."
				}
			},
			"property": {
				"additionalContacts": {
					"label": "Choisir des utilisateurs",
					"guide": "Souhaitez-vous ajouter des utilisateurs individuels ?",
					"hint": "Un ou plusieurs utilisateurs ont été ajoutés automatiquement à ce groupe via la fonction principale ou l'accès à une maison.",
					"placeholder": "Choisir un utilisateur"
				},
				"description": {
					"label": "Description",
					"guide": "Qui pouvez-vous atteindre avec ce groupe de communication ?",
					"placeholder": "Entrez une description"
				},
				"includedContacts": {
					"label": "Contacts inclus",
					"guide": "Sélectionnez les contacts à inclure dans ce groupe.",
					"placeholder": "Trouver contact(s)"
				},
				"includedGroups": {
					"label": "Groupes inclus",
					"guide": "Sélectionnez les groupes de communication à inclure dans ce groupe.",
					"placeholder": "Trouver groupe(s) de communication"
				},
				"name": {
					"label": "Nom",
					"placeholder": "Entrez un nom"
				}
			}
		},
		"contact": {
			"list": {
				"emptySearch": {
					"title": "Aucun contact trouvé",
					"message": "Aucun contact ne correspond à votre recherche."
				}
			}
		},
		"document": {
			"list": {
				"emptyData": {
					"title": "Aucun document",
					"message": "Il n'y a pas encore de documents ajoutés."
				}
			},
			"property": {
				"createdBy": {
					"label": "Par"
				},
				"createdOn": {
					"label": "Ajouté le"
				},
				"name": {
					"label": "Nom document"
				}
			}
		},
		"evaluation": {
			"list": {
				"emptyData": {
					"title": "Aucune évaluation",
					"message": "Il n'y a pas encore d'évaluations."
				}
			},
			"property": {
				"alternativeMeasures": {
					"label": "Autres actions"
				},
				"decisions": {
					"label": "Décision prise",
					"placeholder": "Ajoutez une description"
				},
				"evaluationDate": {
					"label": "Date de l’évaluation",
					"placeholder": "Sélectionnez la date"
				},
				"evaluationDecisions": {
					"label": "Décision"
				},
				"isolationMeasures": {
					"label": "Mesures d'isolement"
				},
				"notes": {
					"label": "Motivation de la décision",
					"placeholder": "Ajoutez une description"
				},
				"restrictiveMeasures": {
					"label": "Mesures de restriction de liberté"
				},
				"subject": {
					"label": "Sujet",
					"empty": "Aucun sujet",
					"placeholder": "Ajoutez une description"
				}
			}
		},
		"evaluationMeasure": {
			"list": {
				"emptyData": {
					"title": "Aucune mesure",
					"message": "Il n'y a pas encore de mesures."
				}
			},
			"property": {
				"details": {
					"label": "Details d'execution",
					"placeholder": "Ajoutez des instructions ou des points d'attention"
				},
				"evaluationDate": {
					"label": "Date de l’évaluation"
				},
				"followUpPlan": {
					"label": "Plan de suivi"
				},
				"name": {
					"label": "Mesure"
				},
				"startDate": {
					"label": "Date de début"
				}
			}
		},
		"evaluationMeasureAlternative": {
			"list": {
				"emptyData": {
					"title": "Aucune mesure alternative",
					"message": "Il n'y a pas encore de mesures alternatives."
				}
			}
		},
		"evaluationMeasureIsolation": {
			"list": {
				"emptyData": {
					"title": "Aucune mesure d'isolement",
					"message": "Il n'y a pas encore de mesures d'isolement."
				}
			}
		},
		"evaluationMeasureRestriction": {
			"list": {
				"emptyData": {
					"title": "Aucune mesure de contention",
					"message": "Il n'y a pas encore de mesures de contention."
				}
			},
			"property": {
				"reason": {
					"label": "Raison",
					"placeholder": "Ajoutez la raison"
				}
			}
		},
		"fallObservation": {
			"property": {
				"causes": {
					"label": "Causes",
					"guide": "Qu'est-ce qui a causé la chute\u202f?",
					"placeholder": "Sélectionnez les causes"
				},
				"causesOther": {
					"label": "Autres causes",
					"placeholder": "Ajoutez une description"
				},
				"consequences": {
					"label": "Conséquences",
					"guide": "Quelles sont les conséquences de la chute\u202f?",
					"placeholder": "Sélectionnez les conséquences"
				},
				"consequencesOther": {
					"label": "Autres conséquences",
					"placeholder": "Ajoutez une description"
				},
				"contexts": {
					"guide": "Que faisait le résident au moment de la chute\u202f?"
				},
				"correctiveActions": {
					"label": "Actions correctives",
					"guide": "Quelles actions ont été prises après la chute\u202f?"
				},
				"correctiveActionsOther": {
					"label": "Autres actions correctives",
					"placeholder": "Ajoutez autres actions correctives"
				},
				"location": {
					"label": "Endroit",
					"guide": "Où le résident est-il tombé\u202f?",
					"placeholder": "Sélectionnez un endroit"
				},
				"locationOther": {
					"label": "Autre endroit",
					"placeholder": "Ajoutez une description"
				}
			}
		},
		"followUpPlan": {
			"list": {
				"emptyData": {
					"title": "Aucun plan de suivi",
					"message": "Il n'y a pas encore de plans de suivi."
				},
				"emptySearch": {
					"title": "Aucun plan de suivi trouvé",
					"message": "Aucun plan de suivi ne correspond à votre recherche."
				}
			},
			"property": {
				"activeAlternativeMeasures": {
					"label": "Mesures alternatives actives"
				},
				"activeIsolationMeasures": {
					"label": "Mesures d'isolement actives"
				},
				"activeRestrictionMeasures": {
					"label": "Mesures de restriction de liberté actives"
				},
				"careTheme": {
					"label": "Thématique",
					"guide": "Sélectionnez la thématique qui correspond à ce plan de suivi",
					"placeholder": "Ajoutez la thématique"
				},
				"careThemeOther": {
					"label": "Autre thème de soins",
					"placeholder": "Ajoutez une description"
				},
				"closedOn": {
					"label": "Clôturé"
				},
				"createdOn": {
					"label": "Date de création"
				},
				"department": {
					"label": "Département"
				},
				"documents": {
					"label": "Documents"
				},
				"followUp": {
					"label": "Suivi"
				},
				"followUpDate": {
					"label": "Date de suivi",
					"placeholder": "Sélectionnez une date"
				},
				"linkedObservations": {
					"label": "Observations liées"
				},
				"measures": {
					"label": "MLC/Isolement",
					"empty": "-"
				},
				"name": {
					"label": "Plan de suivi"
				},
				"problemStatement": {
					"label": "Raison du plan de suivi",
					"guide": "Décrivez pourquoi ce plan de suivi est créé",
					"placeholder": "Ajoutez la raison"
				},
				"resident": {
					"label": "Résident"
				},
				"title": {
					"label": "Titre du plan de suivi",
					"guide": "Indiquez un titre court et clair pour le plan de suivi (max 50 caractères)",
					"placeholder": "Ajoutez le titre"
				}
			}
		},
		"hq": {
			"property": {
				"sites": {
					"empty": "Il n'y a pas encore de sites créés."
				},
				"supportInfo": {
					"empty": "Vous n’avez pas encore ajouté de coordonnées pour le helpdesk interne."
				}
			}
		},
		"incontinenceObservation": {
			"property": {
				"consequences": {
					"label": "Conséquences",
					"guide": "Quels problèmes d’hygiène ou de confort ont été constatés\u202f?",
					"placeholder": "Sélectionnez les conséquences"
				},
				"consequencesOther": {
					"label": "Autres conséquences",
					"placeholder": "Ajoutez une description"
				},
				"contexts": {
					"guide": "Quand l'incontinence est-elle apparue\u202f?"
				},
				"type": {
					"label": "Type d'incontinence",
					"guide": "Quel est le type d'incontinence\u202f?",
					"placeholder": "Sélectionnez un type"
				}
			}
		},
		"infectionObservation": {
			"property": {
				"severity": {
					"label": "Gravité",
					"guide": "Quelle est la gravité des symptômes\u202f?"
				},
				"symptoms": {
					"label": "Symptômes",
					"guide": "Quels symptômes d'infection présente le résident\u202f?"
				},
				"symptomsOther": {
					"label": "Autre",
					"placeholder": "Ajoutez une description"
				}
			}
		},
		"linkedObservation": {
			"list": {
				"emptyData": {
					"title": "Aucune observation liée trouvée",
					"message": "Il n'y a pas encore d'observations liées enregistrées."
				}
			}
		},
		"observation": {
			"list": {
				"emptyData": {
					"title": "Aucune observation trouvée",
					"message": "Il n'y a pas encore d'observations enregistrées."
				},
				"emptySearch": {
					"title": "Aucune observation trouvée",
					"message": "Aucune observation ne correspond à votre recherche."
				}
			},
			"property": {
				"contexts": {
					"label": "Contexte",
					"placeholder": "Sélectionnez un contexte"
				},
				"contextsOther": {
					"label": "Autre contexte",
					"placeholder": "Ajoutez une description"
				},
				"createdBy": {
					"label": "Employé"
				},
				"createdOn": {
					"label": "Moment de l'enregistrement"
				},
				"department": {
					"label": "Département lors de l'observation",
					"unknown": "Inconnu"
				},
				"linkedObservations": {
					"label": "Observations liées"
				},
				"notes": {
					"label": "Remarques",
					"guide": "Ajoutez vos notes ici",
					"placeholder": "Ajoutez vos notes ici"
				},
				"observationType": {
					"label": "Type",
					"placeholder": "Sélectionnez un type"
				},
				"observedOn": {
					"label": "Moment de l'observation",
					"placeholder": "Sélectionnez la date et l'heure"
				},
				"occurredOn": {
					"label": "Moment de l'événement"
				},
				"occurredOnDate": {
					"label": "Date de l'événement",
					"placeholder": "Sélectionnez la date"
				},
				"occurredOnPartOfDay": {
					"label": "Partie\u00A0de la\u00A0journée",
					"placeholder": "Sélectionnez une partie de la journée"
				},
				"resident": {
					"label": "Résident",
					"unknown": "Résident inconnu"
				}
			}
		},
		"organisingAuthority": {
			"list": {
				"emptyData": {
					"title": "Aucun pouvoirs organisateurs trouvés",
					"message": "Il n'y a pas encore de pouvoirs organisateurs créés."
				}
			}
		},
		"permission": {
			"list": {
				"emptyData": {
					"title": "Aucune permission trouvée",
					"message": "Aucune permission n'a été trouvée."
				}
			}
		},
		"physicalComplaintObservation": {
			"property": {
				"complaintOther": {
					"label": "Autre",
					"placeholder": "Ajoutez une description"
				},
				"complaints": {
					"label": "Type des plaintes",
					"guide": "Quelles plaintes physiques le résident présente-t-il\u202f?"
				},
				"severity": {
					"label": "Gravité",
					"guide": "Quelle est la gravité des plaintes\u202f?"
				}
			}
		},
		"recipient": {
			"list": {
				"emptySearch": {
					"title": "Aucun destinataire trouvé",
					"message": "Aucun destinataire ne correspond à votre recherche."
				},
				"search": {
					"placeholder": "Chercher un destinataire..."
				}
			}
		},
		"resident": {
			"property": {
				"evaluationMeasuresActive": {
					"label": "Mesures actives"
				},
				"evaluationMeasuresStopped": {
					"label": "Mesures levées"
				},
				"firstName": {
					"label": "Prénom"
				},
				"lastName": {
					"label": "Nom"
				}
			}
		},
		"role": {
			"list": {
				"emptyData": {
					"title": "Aucun rôle trouvé",
					"message": "Il n'y a pas encore de rôles créés."
				}
			}
		},
		"site": {
			"list": {
				"emptyData": {
					"title": "Aucun site trouvé",
					"message": "Il n'y a pas encore de sites créés."
				}
			},
			"property": {
				"supportInfo": {
					"empty": "Vous n’avez pas encore ajouté de coordonnées pour le helpdesk interne."
				}
			}
		},
		"submittedAssessment": {
			"list": {
				"emptyData": {
					"title": "Aucune échelle soumise",
					"message": "Il n'y a pas encore d'échelles soumises."
				}
			},
			"property": {
				"createdBy": {
					"label": "Employé"
				},
				"createdOn": {
					"label": "Moment de l'enregistrement"
				},
				"details": {
					"label": "Détails"
				},
				"documents": {
					"label": "Pièces jointes"
				},
				"includeInBriefing": {
					"label": "Inclus dans le briefing?"
				},
				"notes": {
					"label": "Remarques",
					"placeholder": "Ajoutez vos remarques ici..."
				},
				"questionnaire": {
					"label": "Questionnaire"
				},
				"resident": {
					"label": "Résident"
				},
				"score": {
					"label": "Score"
				},
				"totalScore": {
					"label": "Score total"
				}
			}
		},
		"user": {
			"list": {
				"emptyData": {
					"title": "Aucun utilisateur trouvé",
					"message": "Il n'y a pas encore d'utilisateurs créés."
				},
				"emptySearch": {
					"title": "Aucun utilisateur trouvé",
					"message": "Aucun utilisateur ne correspond à votre recherche."
				}
			}
		}
	}
}
